import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../environments/environment';

@Pipe({
    name: 'storageLink'
})
export class StorageLinkPipe implements PipeTransform {

    static get PARTS() {
        return [environment.backend, 'storage'];
    }

    transform(path: string, subFolder?: string): string {
        if (!path) {
            return null;
        }
        const parts = StorageLinkPipe.PARTS;
        subFolder && parts.push(subFolder);
        parts.push(path);
        return parts.join('/');
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/storage-link/storage-link.pipe.ts